import { loadGB } from './plugins/loadGB';
import { loadImageBitmap } from './plugins/loadImageBitmap';
export default {
    loadGB,
    loadImageBitmap,
};
